import React from 'react';
import V2Layout from './Layout';
import DeviceList from '../../components/v2/devices/DeviceList.component';

class Devices extends React.Component {

    constructor(props) {
        super(props);
    }

    async componentDidMount() {
    }

    render() {
        return (
            <V2Layout
                currentMenu='devices'
            >
                <DeviceList />
            </V2Layout>
        )
    }
}

export default Devices;
